const SDK = window.SDK;
export default SDK;